export default __webpack_public_path__ + "static/media/AfterMeal.85551d81.svg";